export default "__VITE_ASSET__BN7HMOoU__"